import { render, staticRenderFns } from "./OperaCouponGoodsWindow.vue?vue&type=template&id=17fa461f&scoped=true&"
import script from "./OperaCouponGoodsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCouponGoodsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCouponGoodsWindow.vue?vue&type=style&index=0&id=17fa461f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fa461f",
  null
  
)

export default component.exports